import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  OnDestroy,
  OnInit,
} from '@angular/core';

import { IGradeUnitListItemDTO } from '@app/infrastructure/models/grade-unit/grade-unit';
import { IPagedResults } from '@app/infrastructure/models/response';
import { ActivatedRoute, Data } from '@angular/router';
import { Observable, Subscription } from 'rxjs';
import { GradeUnitService } from '@app/infrastructure/core/services/api/grade-unit.service';
import { GradeRoute } from '@app/infrastructure/models/grade-level';
import { SelectedGradeStateService } from '@app/infrastructure/core/services/state/selected-grade-state.service';

@Component({
  selector: 'app-unit-list',
  template: `<app-shared-grade-unit-list-presentation
    [gradeUnitList]="gradeUnitList$ | async"
    [routeData]="data$ | async"
    (gradeSelection)="getGradeUnitList($event)"
  ></app-shared-grade-unit-list-presentation>`,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SharedGradeUnitListSmartComponent implements OnInit, OnDestroy {
  public gradeUnitList$: Observable<IPagedResults<IGradeUnitListItemDTO>>;
  public emitGetGradeUnitList = new EventEmitter<void>();
  public gradeLevel: string = '';
  public unitNumber: string = '';
  public updateGradeUnitPath: string = '';
  public data$: Observable<Data>;

  private studentId: string = '';
  private subscriptions: Subscription[] = [];
  constructor(
    private activatedRoute: ActivatedRoute,
    private gradeUnitService: GradeUnitService,
    private selectedGradeState: SelectedGradeStateService,
  ) {}

  public ngOnInit(): void {
    this.data$ = this.activatedRoute.data;
    this.studentId = this.activatedRoute.snapshot.data.userProfile?.student?.id;
    const subscription = this.activatedRoute.params.subscribe((param) => {
      this.selectedGradeState.selectedGrade = param.gradeLevel;
    });
    this.subscriptions.push(subscription);
  }

  public ngOnDestroy(): void {
    this.subscriptions.forEach((sub) => sub.unsubscribe());
  }

  public getGradeUnitList(gradeNum: number): void {
    if (this.studentId) {
      this.gradeUnitList$ =
        this.gradeUnitService.getStudentGradeUnitListByGradeLevel(
          this.studentId,
          this.convertGrade(gradeNum),
        );
    } else {
      this.gradeUnitList$ = this.gradeUnitService.getGradeUnitListByGradeLevel(
        this.convertGrade(gradeNum),
      );
    }
  }

  private convertGrade(i: number): GradeRoute {
    switch (i) {
      case 0:
        return GradeRoute.KINDERGARTEN;
      case 1:
        return GradeRoute.FIRST;
      case 2:
        return GradeRoute.SECOND;
      case 3:
        return GradeRoute.THIRD;
      case 4:
        return GradeRoute.FOURTH;
      case 5:
        return GradeRoute.FIFTH;
      case 6:
        return GradeRoute.SIXTH;
      default:
        return GradeRoute.MIXED;
    }
  }
}
